import React from "react";
// eslint-disable-next-line import/no-cycle
import { SvgProps } from ".";

export const Check: React.FC<SvgProps> = ({ fill }) => {
  return (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 40 40"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="Check"
    >
      <title id="Check">Check</title>
      <g
        id="Check"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Group">
          <rect id="Rectangle" x="0" y="0" width="40" height="40" />
          <polyline
            id="Path"
            stroke={fill || "#252525"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="33.75 11.2507812 16.25 28.75 7.5 20.0007812"
          />
        </g>
      </g>
    </svg>
  );
};

export default {};
